exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2wscP {\n  height: 50px;\n  margin-top: 20px;\n}\n._30SM6 {\n  height: 40px;\n}\n.pFOw0 {\n  margin: 0 0 4px 40%;\n}\n.V1W-y {\n  padding-left: 20px;\n}\n", ""]);

// Exports
exports.locals = {
	"exchangeRateBox": "_2wscP",
	"field": "_30SM6",
	"errorText": "pFOw0",
	"depositsPaidIndent": "V1W-y"
};